interface UmbracoServices {
  editorState: Function | any;
  editorService: Function | any;
  userService: Function | any;
  memberGroupResource: Function | any;
}

export function UmbracoBridge(): UmbracoServices {
  // @ts-ignore
  return window.UmbracoBridge;
}
